import { useAuthStore } from '@stores/authStore';
import { useDataConnectionsStore } from '@stores/call/dataConnectionsStore';
import { defineStore } from 'pinia';
import { Subscription } from 'rxjs';
import { ref } from 'vue';

export const useCallChatStore = defineStore('callChat', () => {
  const authStore = useAuthStore();
  const dataConnectionsStore = useDataConnectionsStore();
  const incommingMsgSubscription = ref<Subscription>();
  const newIncomingMsg = ref<boolean>(false);
  const messages = ref<
    {
      text: string;
      name: string;
      date: Date;
      type: 'local' | 'remote';
    }[]
  >([]);

  const subscribeNewIncommingMsg = () => {
    if (incommingMsgSubscription.value && !incommingMsgSubscription.value.closed) {
      incommingMsgSubscription.value.unsubscribe();
    }
    incommingMsgSubscription.value = dataConnectionsStore.incommingMsg.subscribe((message) => {
      newIncomingMsg.value = true;
      addIncomingMessage(message.msg, message.name);
    });
  };

  const addIncomingMessage = (text: string, name: string) => {
    messages.value.push({
      text,
      name,
      date: new Date(),
      type: 'remote',
    });
  };

  const addOutgoingMessage = (text: string) => {
    messages.value.push({
      name:
        authStore.authContext?.user.firstName + ' ' + authStore.authContext?.user.lastName || '',
      text: text.slice(),
      date: new Date(),
      type: 'local',
    });
  };

  const newIncommingMsgWasSeen = () => {
    newIncomingMsg.value = false;
  };

  const unsubscribeNewIncomingMsg = () => {
    if (incommingMsgSubscription.value && !incommingMsgSubscription.value.closed) {
      incommingMsgSubscription.value.unsubscribe();
    }
  };

  const clearMessages = () => {
    messages.value = [];
  };

  return {
    newIncomingMsg,
    newIncommingMsgWasSeen,
    subscribeNewIncommingMsg,
    unsubscribeNewIncomingMsg,
    addOutgoingMessage,
    clearMessages,
    messages,
  };
});
